import { apiService } from './apiService';

export const tickerService = {
  async topPostcodes({ limit = 5, days = 7 } = {}) {
    const qs = new URLSearchParams({ limit, days }).toString();
    return apiService.get(`/api/v1/ticker/top-postcodes?${qs}`, { includeAuth: false });
  },

  // Open group-buy groups looking for a provider: service, pincode, member count.
  async openGroups({ limit = 10, postcode } = {}) {
    const params = { limit };
    if (postcode) params.postcode = postcode;
    const qs = new URLSearchParams(params).toString();
    return apiService.get(`/api/v1/ticker/open-groups?${qs}`, { includeAuth: false });
  },
};

export default tickerService;
